// Utils
import { getSourcePage } from 'Shared/utils/getSourcePage';

// Hooks
import { usePITracking } from './use-pi-tracking';

type Props = {
  component?: string;
};

export const useBaTracking = ({ component = '' }: Props = {}) => {
  const { trackPIEvent } = usePITracking();

  const track = ({ eventName, properties = {} }) => {
    trackPIEvent({
      eventName,
      properties: {
        component,
        sourcePage: getSourcePage(),
        ...properties,
      },
    });
  };

  const trackTakeAssessmentButtonClick = () => {
    track({ eventName: 'Clicked to Take PI Behavioral Assessment' });
  };

  const trackSendAssessmentButtonClick = () => {
    track({
      eventName: 'Clicked to Send PI Behavioral Assessment',
    });
  };

  const trackViewBaReportButtonClick = () => {
    track({
      eventName: 'Clicked to View PI Behavioral Report',
    });
  };

  const trackRelationshipTabButtonClick = () => {
    track({
      eventName: 'Clicked Relationship Tab',
    });
  };

  const trackRestartAssessmentButtonClick = () => {
    track({
      eventName: 'Clicked to Restart PI Behavioral Assessment',
    });
  };

  const trackStrengthsAndCautionsClick = ({ isStrengthsAndCautionsOpen }: { isStrengthsAndCautionsOpen: boolean }) => {
    const action = isStrengthsAndCautionsOpen ? 'Expand' : 'Close';
    track({
      eventName: `Clicked to ${action} Strengths and Cautions`,
    });
  };

  const trackLearnMorePIBasicsClick = () => {
    track({
      eventName: 'Clicked to Learn More PI Basics',
    });
  };

  return {
    trackRestartAssessmentButtonClick,
    trackTakeAssessmentButtonClick,
    trackViewBehavioralReportButtonClick: trackViewBaReportButtonClick,
    trackStrengthsAndCautionsClick,
    trackLearnMorePIBasicsClick,
    trackSendAssessmentButtonClick,
    trackRelationshipTabButtonClick,
  };
};
